export enum BlogListType {
  FIRST_VENUE,
  FIRST_TEXT,
}
